"use client"; // ✅ Ensure this is a Client Component


import GetStartedButton from "@/app/components/Utils/GetStartedButton";

import React from "react";
import {usePathname} from "next/navigation";

export default function Focus() {
    const pathname = usePathname(); // ✅ Get the current route

    return (
        <div className="bg-white">
            <div className="px-6 py-24 sm:px-6 sm:py-32 lg:px-8">
                <div className="mx-auto max-w-2xl text-center">
                    <h2 className="text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl">
                        Focus on growing your business leave the tech to us!
                    </h2>
                    <p className="mx-auto mt-6 max-w-xl text-lg/8 text-pretty text-gray-600">
                        FullStack Software Labs is your all in one solution. We deliver scalable, high quality, and cost effective technology tailored to your business
                        needs.
                    </p>

                    {pathname !== "/contact" && (
                        <div className="mt-10 flex items-center justify-center gap-x-6">
                            <GetStartedButton />
                        </div>
                    )}


                </div>
            </div>
        </div>
    )
}

